'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'

import {
  AMERICAN_FOOTBALL_IMG,
  BASKETBALL_IMG,
  FOOTBALL_IMG,
  PROCESS_STEP_COPY,
  PROCESS_STEP_KEYS,
  WHISTLE_IMG
} from '../fansLandingContent.constants'
import S from '../FansLandingContent.module.scss'

const FansSimpleProcess = () => {
  const t = useTranslations('fansPage.hero')

  return (
    <>
      <p className={S.simpleProcessEyebrow}>{t('simpleProcessEyebrow')}</p>

      <div className={S.simpleProcessHeadlineCluster}>
        <div className={S.simpleProcessGlow} aria-hidden />

        <p className={S.simpleProcessHeadline}>{t('simpleProcessHeadline')}</p>
      </div>

      <div className={S.simpleProcessSteps}>
        {PROCESS_STEP_KEYS.map((key, index) => {
          const stepNum = index + 1

          return (
            <div key={key} className={S.processStep}>
              {stepNum === 1 && (
                <div className={S.step1FootballSlot}>
                  <div className={S.step1Football}>
                    <Image
                      src={FOOTBALL_IMG}
                      alt=""
                      width={150}
                      height={150}
                      priority
                      className={S.step1FootballImg}
                    />

                    <div className={S.step1FootballNoise} aria-hidden />
                  </div>
                </div>
              )}

              {stepNum === 2 && (
                <div className={S.step2BasketballSlot}>
                  <div className={S.step2Basketball}>
                    <Image
                      src={BASKETBALL_IMG}
                      alt=""
                      width={150}
                      height={150}
                      priority
                      className={S.step2BasketballImg}
                    />

                    <div className={S.step2BasketballNoise} aria-hidden />
                  </div>
                </div>
              )}

              {stepNum === 3 && (
                <div className={S.step3AmericanFootballSlot}>
                  <div className={S.step3AmericanFootball}>
                    <Image
                      src={AMERICAN_FOOTBALL_IMG}
                      alt=""
                      width={150}
                      height={150}
                      priority
                      className={S.step3AmericanFootballImg}
                    />

                    <div className={S.step3AmericanFootballNoise} aria-hidden />
                  </div>
                </div>
              )}

              {stepNum === 4 && (
                <div className={S.step4WhistleSlot}>
                  <div className={S.step4Whistle}>
                    <Image
                      src={WHISTLE_IMG}
                      alt=""
                      width={150}
                      height={150}
                      priority
                      className={S.step4WhistleImg}
                    />

                    <div className={S.step4WhistleNoise} aria-hidden />
                  </div>
                </div>
              )}

              <div className={S.processStepTopRule} aria-hidden />

              <p className={S.processStepLabel}>{t(key)}</p>

              <div className={S.processStepBody}>
                <div className={S.processStepTitle}>
                  {PROCESS_STEP_COPY[index].titleKeys.map(titleKey => (
                    <span key={titleKey} className={S.processStepTitleLine}>
                      {t(titleKey)}
                    </span>
                  ))}
                </div>

                <div className={S.processStepSubtitle}>
                  {PROCESS_STEP_COPY[index].bodyKeys.map(bodyKey => (
                    <span key={bodyKey} className={S.processStepSubtitleLine}>
                      {t(bodyKey)}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default FansSimpleProcess
